import { jsx } from 'react/jsx-runtime';
import { cn } from '../../../lib/utils.js';

const SelectionSummary = ({ children, className }) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "flex flex-col border border-primary-04 bg-primary-background-08 p-6 gap-2 rounded-[16px] body-md",
        className
      ),
      children
    }
  );
};
const SelectionTitle = ({ children }) => {
  return /* @__PURE__ */ jsx("div", { className: "title heading-h5 font-weight-medium text-primary-01", children });
};
const SelectionTitleSub = ({ children }) => {
  return /* @__PURE__ */ jsx("div", { className: "title-sub heading-h4 font-weight-medium text-primary-01", children });
};
const SelectionDesc = ({ children }) => {
  return /* @__PURE__ */ jsx("div", { className: "desc body-lg text-basic-03", children });
};
const SelectionText = ({ children }) => {
  return /* @__PURE__ */ jsx("div", { className: "text body-sm text-basic-02", children });
};

export { SelectionDesc, SelectionSummary, SelectionText, SelectionTitle, SelectionTitleSub };
